import { useLayoutEffect, useState } from 'react';

/**
 * Whether a one-line element cuts its text off, kept current as it resizes.
 * Pass the element itself (a callback ref's state), so a remounted element is
 * measured again.
 */
export function useTruncated(element: HTMLElement | null, text: string): boolean {
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    if (!element) return;

    const measure = () => setTruncated(element.scrollWidth > element.clientWidth);
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, text]);

  return truncated;
}
